import { Box, Button, Typography } from "@mui/material"
import { awsImageRootUrl } from "lib/constants"
import moment from "moment"
import { availabilityModalStyles } from "styles/AvailabilityDirectory/availabilityModal.styles"

const ConfirmShareDialog = ({ data, handleConfirmShareDialogClose, quickLinkSharing, handleConfirmShareAndSend, type }: any) => {
    console.log("data", data)
    return (
        <Box sx={availabilityModalStyles.directLinkBodyContainer}>
            <Box
                sx={{
                    ...availabilityModalStyles.directLinkModalBody,
                    width: { xs: '100%', sm: '590px' },
                }}
            >
                <Box
                    component="img"
                    src={data?.itemImages?.[0].uri ? awsImageRootUrl + "/" + data?.itemImages?.[0].uri : awsImageRootUrl + "/" + data?.itemImages?.[0]}
                    alt={data?.item_name}
                    sx={availabilityModalStyles.imageStyles}
                />
                <Box padding={"8px"}>
                    <Typography sx={availabilityModalStyles.cardTitle}>
                        {data?.item_name ? data.item_name : data?.itemDetails?.[0]?.item_name}
                    </Typography>
                    <hr />
                    <Typography sx={availabilityModalStyles.cardDate}>
                        {data?.date
                            ? moment(data.date, "YYYY-MM-DD").format(
                                "ddd, MMM DD, YYYY"
                            )
                            : ""}
                    </Typography>
                    {
                        type === "quick_link" && (
                            data?.start_time && (
                                <Typography sx={availabilityModalStyles.cardTime}>
                                    {data?.start_time}
                                </Typography>
                            )
                        )
                    }
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                        }}
                    >
                        {
                            type === "create_availability" && (
                                data?.start_time && (
                                    <Typography sx={availabilityModalStyles.cardTime}>
                                        {data?.start_time}
                                    </Typography>
                                )
                            )
                        }

                        <Typography sx={availabilityModalStyles.cardPrice}>
                            Price:{" "}
                            <Typography component="span" style={availabilityModalStyles.boldText}>
                                ${data?.price ? data.price : data?.itemDetails?.[0]?.price}
                            </Typography>
                        </Typography>
                        <Typography sx={availabilityModalStyles.cardPays}>
                            Pays:{" "}
                            <Typography component="span" style={availabilityModalStyles.boldText}>
                                {data?.commission ? data.commission : data?.itemDetails?.[0]?.comission}% (
                                ${(
                                    ((data?.price ? data.price : data?.itemDetails?.[0]?.price || 0) *
                                        (data?.commission ? data.commission : data?.itemDetails?.[0]?.comission || 0)) /
                                    100
                                ).toFixed(0)}
                                )
                            </Typography>
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <Box sx={availabilityModalStyles.directLinkModalFooter}>
                <Button
                    variant="contained"
                    size="small"
                    sx={availabilityModalStyles.flex1}
                    onClick={handleConfirmShareAndSend}
                    disabled={quickLinkSharing}
                >
                    {quickLinkSharing ? "Sharing..." : "Share"}
                </Button>
                <Button
                    variant="outlined"
                    size="small"
                    sx={availabilityModalStyles.flex1}
                    onClick={handleConfirmShareDialogClose}
                >
                    Cancel
                </Button>
            </Box>
        </Box>
    )
}

export default ConfirmShareDialog